export const permissionTree = [
    {
        key: 'admin_view',
        title: 'Admin View',
        children: [
            { key: 'company', title: 'Company Management' },
            {
                key: 'user', title: 'User Management', children: [
                    { key: 'user_create_feature', title: 'Create User' },
                    { key: 'user_edit_feature', title: 'Edit User' },
                    { key: 'user_delete_feature', title: 'Delete User' },
                    { key: 'user_view_feature', title: 'View User' },
                ]
            },
            // { key: 'profile', title: 'Profile Management' },
            {
                key: 'role_menu', title: 'Profile Management', children: [
                    { key: 'role_create_feature', title: 'Create Profile' },
                    { key: 'role_edit_feature', title: 'Edit Profile' },
                    { key: 'role_delete_feature', title: 'Delete Profile' },
                    { key: 'role_view_feature', title: 'View Profile' },
                ]
            },
            {
                key: 'certify_request_menu', title: 'certifyRequest',
            },
            {
                key: 'facility', title: 'Facility Management', children: [
                    { key: 'facility_create_feature', title: 'Create Facility' },
                    { key: 'facility_edit_feature', title: 'Edit Facility' },
                    { key: 'facility_delete_feature', title: 'Delete Facility' },
                    { key: 'facility_view_feature', title: 'View Facility' },
                ]
            },

            { key: 'admin_settings_menu', title: 'Settings' },
            { key: 'admin_benchmark_menu', title: 'Benchmark', children: [
                {key: 'admin_benchmark_view_feature', title: 'View Benchmark'},
                {key: 'admin_benchmark_delete_feature', title: 'Delete Benchmark'},
            ] },
            { key: 'admin_template_menu', title: 'Template', children: [
                { key: 'equipmentCategory', title: 'Equipment Category' },
                { key: 'functionform', title: 'Functional Form' },
            ] },
        ]
    },
    {
        key: 'facility_view',
        title: 'Facility View',
        children: [
            {
                key: 'dashboard_menu',
                title: 'Dashboard',
            },
            {
                key: 'utility_menu',
                title: 'Utility',
                children: [
                    { key: 'summary_menu', title: 'Summary' },
                    { key: 'electricity_menu', title: 'Electricity', children: [
                        { key: 'electricity_feature_readonly', title: 'Read Only' },
                        { key: 'electricity_feature_editable', title: 'Editable' },
                        { key: 'electricity_feature_full', title: 'Full Access' },
                    ] },
                    { key: 'gas_menu', title: 'Gas', children: [
                        { key: 'gas_feature_readonly', title: 'Read Only' },
                        { key: 'gas_feature_editable', title: 'Editable' },
                        { key: 'gas_feature_full', title: 'Full Access' },
                    ] },
                    { key: 'savings_menu', title: 'Savings' },
                    { key: 'certify_menu', title: 'Certify' },
                ]
            },
            {
                key: 'equipment_folder_menu',
                title: 'Equipment Management',
                children: [
                    { key: 'equipment_menu', title: 'Equipment', children: [
                        { key: 'equipment_feature_readonly', title: 'Read Only' },
                        { key: 'equipment_feature_editable', title: 'Editable' },
                        { key: 'equipment_feature_full', title: 'Full Access' },
                    ] },
                    { key: 'functiontesting', title: 'Function Testing' },
                ]
            },
            {
                key: 'benchmark_menu', title: 'Benchmark Analysis', children: [
                    { key: 'inter_benchmark_menu', title: 'Inter-Company Benchmark' },
                    { key: 'all_facility_benchmark_menu', title: 'All Facility Benchmark' },
                    { key: 'national_benchmark_menu', title: 'National Benchmark' },
                ]
            },
            // { key: 'electricity', title: 'Electricity Data' },
            // { key: 'gas', title: 'Gas Data' },
            // { key: 'stationtemperature', title: 'Station Temperature' },
            // { key: 'Scenario', title: 'Scenario Analysis' },
            { key: 'workorder_menu', title: 'Work Order', children: [
                { key: 'workorder_feature_readonly', title: 'Read Only' },
                { key: 'workorder_feature_editable', title: 'Editable' },
                { key: 'workorder_feature_full', title: 'Full Access' },
            ] },
            { key: 'project', title: 'Project Management' },
            // { key: 'functionform', title: 'Function Form' },
            { key: 'log', title: 'System Logs' },
            { key: 'customreport', title: 'Custom Reports' },
            { key: 'filemanage', title: 'File Management' },
            { key: 'tags', title: 'Tags Management' },


        ]
    },
    {
        key: 'portfolio_view',
        title: 'Portfolio View',
        children: [
            { key: 'portfolio_dashboard_menu', title: 'Portfolio Dashboard' },
        ]
    }
];